module.exports = __webpack_public_path__ + "media/images/plans/e-photo_studio/e-photo_studio-2-4aba0f2e353dfb3a2d4f50bab2dd03f9.png";